var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-row",
    { attrs: { gutter: 24 } },
    [
      _c(
        "a-col",
        { attrs: { md: 24 } },
        [
          _c(
            "a-card",
            { style: _vm.cardStyle, attrs: { bordered: false } },
            [
              _c(
                "a-tabs",
                { attrs: { "default-active-key": "map" } },
                [
                  _c(
                    "a-tab-pane",
                    { key: "map", attrs: { tab: "商品映射" } },
                    [
                      _c(
                        "div",
                        { staticClass: "table-page-search-wrapper" },
                        [
                          _c(
                            "a-form",
                            {
                              attrs: { layout: "inline" },
                              nativeOn: {
                                keyup: function ($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  )
                                    return null
                                  return _vm.searchQuery.apply(null, arguments)
                                },
                              },
                            },
                            [
                              _c(
                                "a-row",
                                { attrs: { gutter: 24 } },
                                [
                                  _c(
                                    "a-col",
                                    { attrs: { md: 6, sm: 24 } },
                                    [
                                      _c(
                                        "a-form-item",
                                        {
                                          attrs: {
                                            label: "商品名称",
                                            labelCol: _vm.labelCol,
                                            wrapperCol: _vm.wrapperCol,
                                          },
                                        },
                                        [
                                          _c("a-input", {
                                            attrs: {
                                              placeholder: "请输入商品名称查询",
                                            },
                                            model: {
                                              value:
                                                _vm.queryParam.materialName,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.queryParam,
                                                  "materialName",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "queryParam.materialName",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "a-col",
                                    { attrs: { md: 6, sm: 24 } },
                                    [
                                      _c(
                                        "a-form-item",
                                        {
                                          attrs: {
                                            label: "合作伙伴",
                                            labelCol: _vm.labelCol,
                                            wrapperCol: _vm.wrapperCol,
                                          },
                                        },
                                        [
                                          _c(
                                            "a-select",
                                            {
                                              attrs: {
                                                placeholder: "请选择伙伴",
                                                "allow-clear": "",
                                              },
                                              model: {
                                                value:
                                                  _vm.queryParam
                                                    .partnerTenantId,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.queryParam,
                                                    "partnerTenantId",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "queryParam.partnerTenantId",
                                              },
                                            },
                                            _vm._l(
                                              _vm.partnerList,
                                              function (p) {
                                                return _c(
                                                  "a-select-option",
                                                  {
                                                    key: p.partnerTenantId,
                                                    attrs: {
                                                      value: p.partnerTenantId,
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                        " +
                                                        _vm._s(p.partnerName) +
                                                        "（" +
                                                        _vm._s(
                                                          p.partnerTenantId
                                                        ) +
                                                        "）\n                      "
                                                    ),
                                                  ]
                                                )
                                              }
                                            ),
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "a-col",
                                    { attrs: { md: 6, sm: 24 } },
                                    [
                                      _c(
                                        "a-form-item",
                                        {
                                          attrs: {
                                            label: "状态",
                                            labelCol: _vm.labelCol,
                                            wrapperCol: _vm.wrapperCol,
                                          },
                                        },
                                        [
                                          _c(
                                            "a-select",
                                            {
                                              attrs: {
                                                placeholder: "全部状态",
                                                "allow-clear": "",
                                              },
                                              model: {
                                                value: _vm.queryParam.status,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.queryParam,
                                                    "status",
                                                    $$v
                                                  )
                                                },
                                                expression: "queryParam.status",
                                              },
                                            },
                                            [
                                              _c(
                                                "a-select-option",
                                                { attrs: { value: "0" } },
                                                [_vm._v("待对方处理")]
                                              ),
                                              _c(
                                                "a-select-option",
                                                { attrs: { value: "1" } },
                                                [_vm._v("已生效")]
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "table-page-search-submitButtons",
                                      staticStyle: {
                                        float: "left",
                                        overflow: "hidden",
                                      },
                                    },
                                    [
                                      _c(
                                        "a-col",
                                        { attrs: { md: 12, sm: 24 } },
                                        [
                                          _c(
                                            "a-button",
                                            {
                                              attrs: { type: "primary" },
                                              on: { click: _vm.searchQuery },
                                            },
                                            [_vm._v("查询")]
                                          ),
                                          _c(
                                            "a-button",
                                            {
                                              staticStyle: {
                                                "margin-left": "8px",
                                              },
                                              on: { click: _vm.searchReset },
                                            },
                                            [_vm._v("重置")]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "table-operator",
                          staticStyle: { "margin-top": "5px" },
                        },
                        [
                          _vm.btnEnableList.indexOf(1) > -1
                            ? _c(
                                "a-button",
                                {
                                  attrs: { type: "primary", icon: "plus" },
                                  on: { click: _vm.handleAdd },
                                },
                                [_vm._v("新增映射")]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                      _c(
                        "section",
                        [
                          _c("a-table", {
                            ref: "table",
                            attrs: {
                              size: "middle",
                              bordered: "",
                              rowKey: "id",
                              columns: _vm.columns,
                              dataSource: _vm.dataSource,
                              pagination: false,
                              scroll: _vm.scroll,
                              loading: _vm.loading,
                            },
                            on: { change: _vm.handleTableChange },
                            scopedSlots: _vm._u([
                              {
                                key: "source",
                                fn: function (text) {
                                  return [
                                    text === "manual"
                                      ? _c("a-tag", [_vm._v("手动")])
                                      : text === "share"
                                      ? _c(
                                          "a-tag",
                                          { attrs: { color: "blue" } },
                                          [_vm._v("分享")]
                                        )
                                      : text === "claim"
                                      ? _c(
                                          "a-tag",
                                          { attrs: { color: "purple" } },
                                          [_vm._v("认领")]
                                        )
                                      : _c("span", [_vm._v(_vm._s(text))]),
                                  ]
                                },
                              },
                              {
                                key: "status",
                                fn: function (text) {
                                  return [
                                    text === "0"
                                      ? _c(
                                          "a-tag",
                                          { attrs: { color: "orange" } },
                                          [_vm._v("待对方处理")]
                                        )
                                      : _c(
                                          "a-tag",
                                          { attrs: { color: "green" } },
                                          [_vm._v("已生效")]
                                        ),
                                  ]
                                },
                              },
                              {
                                key: "action",
                                fn: function (text, record) {
                                  return _c(
                                    "span",
                                    {},
                                    [
                                      _vm.btnEnableList.indexOf(1) > -1
                                        ? _c(
                                            "a-popconfirm",
                                            {
                                              attrs: {
                                                title: "确定删除该映射吗?",
                                              },
                                              on: {
                                                confirm: () =>
                                                  _vm.handleDelete(record.id),
                                              },
                                            },
                                            [_c("a", [_vm._v("删除")])]
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  )
                                },
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                      _c("a-pagination", {
                        staticStyle: {
                          "margin-top": "16px",
                          "text-align": "right",
                        },
                        attrs: {
                          current: _vm.ipagination.current,
                          pageSize: _vm.ipagination.pageSize,
                          total: _vm.ipagination.total,
                        },
                        on: {
                          change: _vm.paginationChange,
                          showSizeChange: _vm.paginationShowSizeChange,
                        },
                      }),
                      _c("item-map-modal", {
                        ref: "modalForm",
                        on: { ok: _vm.modalFormOk },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "a-tab-pane",
                    { key: "alias", attrs: { tab: "商品别名" } },
                    [
                      _c(
                        "div",
                        { staticClass: "table-page-search-wrapper" },
                        [
                          _c(
                            "a-form",
                            {
                              attrs: { layout: "inline" },
                              nativeOn: {
                                keyup: function ($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  )
                                    return null
                                  return _vm.loadAliases(1)
                                },
                              },
                            },
                            [
                              _c(
                                "a-row",
                                { attrs: { gutter: 24 } },
                                [
                                  _c(
                                    "a-col",
                                    { attrs: { md: 6, sm: 24 } },
                                    [
                                      _c(
                                        "a-form-item",
                                        {
                                          attrs: {
                                            label: "别名",
                                            labelCol: _vm.labelCol,
                                            wrapperCol: _vm.wrapperCol,
                                          },
                                        },
                                        [
                                          _c("a-input", {
                                            attrs: {
                                              placeholder: "请输入别名查询",
                                            },
                                            model: {
                                              value: _vm.aliasQueryParam.alias,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.aliasQueryParam,
                                                  "alias",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "aliasQueryParam.alias",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "a-col",
                                    { attrs: { md: 6, sm: 24 } },
                                    [
                                      _c(
                                        "a-form-item",
                                        {
                                          attrs: {
                                            label: "客户",
                                            labelCol: _vm.labelCol,
                                            wrapperCol: _vm.wrapperCol,
                                          },
                                        },
                                        [
                                          _c(
                                            "a-select",
                                            {
                                              attrs: {
                                                placeholder:
                                                  "全部（含客户专属）",
                                                "allow-clear": "",
                                              },
                                              model: {
                                                value:
                                                  _vm.aliasQueryParam
                                                    .customerTenantId,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.aliasQueryParam,
                                                    "customerTenantId",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "aliasQueryParam.customerTenantId",
                                              },
                                            },
                                            [
                                              _c(
                                                "a-select-option",
                                                { attrs: { value: 0 } },
                                                [_vm._v("通用（所有客户）")]
                                              ),
                                              _vm._l(
                                                _vm.customerPartnerList,
                                                function (p) {
                                                  return _c(
                                                    "a-select-option",
                                                    {
                                                      key: p.partnerTenantId,
                                                      attrs: {
                                                        value:
                                                          p.partnerTenantId,
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                        " +
                                                          _vm._s(
                                                            p.partnerName
                                                          ) +
                                                          "（" +
                                                          _vm._s(
                                                            p.partnerTenantId
                                                          ) +
                                                          "）\n                      "
                                                      ),
                                                    ]
                                                  )
                                                }
                                              ),
                                            ],
                                            2
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "table-page-search-submitButtons",
                                      staticStyle: {
                                        float: "left",
                                        overflow: "hidden",
                                      },
                                    },
                                    [
                                      _c(
                                        "a-col",
                                        { attrs: { md: 12, sm: 24 } },
                                        [
                                          _c(
                                            "a-button",
                                            {
                                              attrs: { type: "primary" },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.loadAliases(1)
                                                },
                                              },
                                            },
                                            [_vm._v("查询")]
                                          ),
                                          _c(
                                            "a-button",
                                            {
                                              staticStyle: {
                                                "margin-left": "8px",
                                              },
                                              on: {
                                                click: _vm.resetAliasQuery,
                                              },
                                            },
                                            [_vm._v("重置")]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "table-operator",
                          staticStyle: { "margin-top": "5px" },
                        },
                        [
                          _vm.btnEnableList.indexOf(1) > -1
                            ? _c(
                                "a-button",
                                {
                                  attrs: { type: "primary", icon: "plus" },
                                  on: { click: _vm.handleAddAlias },
                                },
                                [_vm._v("新增别名")]
                              )
                            : _vm._e(),
                          _vm.btnEnableList.indexOf(1) > -1 &&
                          _vm.aliasSelectedRowKeys.length > 0
                            ? _c(
                                "a-popconfirm",
                                {
                                  attrs: { title: "确定删除选中的别名吗?" },
                                  on: { confirm: _vm.handleBatchDeleteAlias },
                                },
                                [
                                  _c(
                                    "a-button",
                                    {
                                      attrs: { type: "danger", icon: "delete" },
                                    },
                                    [
                                      _vm._v(
                                        "批量删除（" +
                                          _vm._s(
                                            _vm.aliasSelectedRowKeys.length
                                          ) +
                                          "）"
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                      _c(
                        "section",
                        [
                          _c("a-table", {
                            attrs: {
                              size: "middle",
                              bordered: "",
                              rowKey: "id",
                              columns: _vm.aliasColumns,
                              dataSource: _vm.aliasDataSource,
                              pagination: false,
                              scroll: _vm.scroll,
                              loading: _vm.aliasLoading,
                              rowSelection: {
                                selectedRowKeys: _vm.aliasSelectedRowKeys,
                                onChange: _vm.onAliasSelectChange,
                              },
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "aliasCustomer",
                                fn: function (text, record) {
                                  return [
                                    !record.customerTenantId ||
                                    Number(record.customerTenantId) === 0
                                      ? _c("a-tag", [_vm._v("通用")])
                                      : _c("span", [_vm._v(_vm._s(text))]),
                                  ]
                                },
                              },
                              {
                                key: "aliasAction",
                                fn: function (text, record) {
                                  return _c(
                                    "span",
                                    {},
                                    [
                                      _vm.btnEnableList.indexOf(1) > -1
                                        ? [
                                            _c(
                                              "a",
                                              {
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.handleEditAlias(
                                                      record
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v("编辑")]
                                            ),
                                            _c("a-divider", {
                                              attrs: { type: "vertical" },
                                            }),
                                            _c(
                                              "a-popconfirm",
                                              {
                                                attrs: {
                                                  title: "确定删除该别名吗?",
                                                },
                                                on: {
                                                  confirm: () =>
                                                    _vm.handleDeleteAlias(
                                                      record.id
                                                    ),
                                                },
                                              },
                                              [_c("a", [_vm._v("删除")])]
                                            ),
                                          ]
                                        : _vm._e(),
                                    ],
                                    2
                                  )
                                },
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                      _c("a-pagination", {
                        staticStyle: {
                          "margin-top": "16px",
                          "text-align": "right",
                        },
                        attrs: {
                          current: _vm.aliasPagination.current,
                          pageSize: _vm.aliasPagination.pageSize,
                          total: _vm.aliasPagination.total,
                        },
                        on: {
                          change: _vm.aliasPaginationChange,
                          showSizeChange: _vm.aliasPaginationShowSizeChange,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "a-modal",
        {
          staticStyle: { top: "100px" },
          attrs: {
            title: _vm.aliasForm.id ? "编辑别名" : "新增别名",
            width: 500,
            visible: _vm.aliasModalVisible,
            confirmLoading: _vm.aliasSaving,
            maskClosable: false,
            cancelText: "取消",
            okText: "保存",
          },
          on: {
            ok: _vm.handleAliasOk,
            cancel: function ($event) {
              _vm.aliasModalVisible = false
            },
          },
        },
        [
          _c(
            "a-form",
            [
              _c(
                "a-form-item",
                {
                  attrs: {
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    label: "客户",
                    extra:
                      "通用别名对所有客户生效；客户专属别名仅对该客户的识别/校正生效",
                  },
                },
                [
                  _c(
                    "a-select",
                    {
                      model: {
                        value: _vm.aliasForm.customerTenantId,
                        callback: function ($$v) {
                          _vm.$set(_vm.aliasForm, "customerTenantId", $$v)
                        },
                        expression: "aliasForm.customerTenantId",
                      },
                    },
                    [
                      _c("a-select-option", { attrs: { value: 0 } }, [
                        _vm._v("通用（所有客户）"),
                      ]),
                      _vm._l(_vm.customerPartnerList, function (p) {
                        return _c(
                          "a-select-option",
                          {
                            key: p.partnerTenantId,
                            attrs: { value: p.partnerTenantId },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(p.partnerName) +
                                "（" +
                                _vm._s(p.partnerTenantId) +
                                "）\n          "
                            ),
                          ]
                        )
                      }),
                    ],
                    2
                  ),
                ],
                1
              ),
              _c(
                "a-form-item",
                {
                  attrs: {
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    label: "商品",
                    required: "",
                  },
                },
                [
                  _c(
                    "a-select",
                    {
                      attrs: {
                        placeholder: "输入名称搜索商品",
                        "show-search": "",
                        "filter-option": false,
                      },
                      on: { search: _vm.handleSearchAliasMaterial },
                      model: {
                        value: _vm.aliasForm.materialId,
                        callback: function ($$v) {
                          _vm.$set(_vm.aliasForm, "materialId", $$v)
                        },
                        expression: "aliasForm.materialId",
                      },
                    },
                    _vm._l(_vm.aliasMaterialList, function (m) {
                      return _c(
                        "a-select-option",
                        { key: m.id, attrs: { value: m.id } },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                m.unit ? m.name + "（" + m.unit + "）" : m.name
                              ) +
                              "\n          "
                          ),
                        ]
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-form-item",
                {
                  attrs: {
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    label: "别名",
                    required: "",
                    extra:
                      "同一客户下别名唯一，如“洋芋”指向“土豆”，用于识别/校正时自动映射",
                  },
                },
                [
                  _c("a-input", {
                    attrs: { placeholder: "请输入别名" },
                    model: {
                      value: _vm.aliasForm.alias,
                      callback: function ($$v) {
                        _vm.$set(_vm.aliasForm, "alias", $$v)
                      },
                      expression: "aliasForm.alias",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }